import React, { useState } from 'react';
import { HiOutlineInformationCircle } from "react-icons/hi2";
import { MdKeyboardArrowDown } from "react-icons/md";
import { Home } from '../../layout/WebsiteSettingsLayout/HomePageSettings/Home'
import { Servicelistingpage } from '../../layout/WebsiteSettingsLayout/ListingPagesSettings/Servicelistingpage'
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css'; // ✅ Correct named import

const LADWebSettings = () => {
  const [showMenu, setShowMenu] = useState(false);
  const [activePage, setActivePage] = useState("listing"); // "home" or "listing"

  return (
    <div className="min-h-screen  ">
  {/* Top Heading */}
  <div className='border-b-2 p-6 '>
    <h1 className='mt-2 text-3xl  text-gray-700 md:ms-10 lg:ms-1'>Website Settings Layout</h1>
  </div>

  {/* Dropdown */}
  <div className='flex w-full  justify-start '>
  <div className=" w-fit mx-auto mt-10 border-2 p-3 relative lg:ms-11  md:ms-14 shadow rounded ">
    <div className="flex items-center gap-2 text-black relative">
      {/* Info Icon with tooltip trigger */}
      <span
        data-tooltip-id="pageTooltip"
        data-tooltip-html={`
          <div class='tooltip-bubble'>
            <div class='tooltip-content'>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.<br />
              Nullam id nulla a elit pharetra gravida. Sed porttitor sapien non ex malesuada.
            </div>
            <div class='tooltip-tail'></div>
          </div>
        `}
        className="text-xl mt-1 cursor-pointer"
      >
        <HiOutlineInformationCircle />
      </span>

      <h1 className="text-xl">
        {activePage === "listing" ? "Listing Service Home Page" : "Home Page"}
      </h1>

      <h1
        className="cursor-pointer text-xl mt-1"
        onClick={() => setShowMenu(!showMenu)}
      >
        <MdKeyboardArrowDown />
      </h1>

      <Tooltip
        id="pageTooltip"
        place="bottom"
        offset={10}
        className="!bg-transparent !p-0 ms-28 !rounded-none"
      />
    </div>

    {showMenu && (
      <div className="absolute top-full left-0  w-60  mt-2 rounded shadow z-10">
        {activePage !== "listing" && (
          <div
            className="cursor-pointer p-2 hover:bg-gray-300"
            onClick={() => {
              setActivePage("listing");
              setShowMenu(false);
            }}
          >
            Listing Service Home Page
          </div>
        )}
        {activePage !== "home" && (
          <div
            className="cursor-pointer p-2 hover:bg-gray-300"
            onClick={() => {
              setActivePage("home");
              setShowMenu(false);
            }}
          >
            Home pages
          </div>
        )}
      </div>
    )}
  </div>
  </div>

  {/* Content */}
  <div className="mt-8 px-4">
    {activePage === "home" && (
       <div className="lg:max-w-[90%]  w-full mx-auto border-2 p-4 lg:ms-7 md:ms-10 rounded-lg  shadow">
        <Home />
      </div>
    )}
    {activePage === "listing" && (
      <div className="lg:max-w-[90%]  w-full mx-auto border-2 p-4 lg:ms-7 md:ms-10 rounded-lg  shadow">
        <Servicelistingpage />
      </div>
    )}
  </div>
</div>

  );
};

export default LADWebSettings;
